import { withPrefix } from 'gatsby'
import routesConfig from 'src/routes.config'
import variables from 'src/styles/variables'

export default {
  metadata: {
    title: 'Simple, integrated data capture and augmentation. - artificial',
    desc: 'Make the most of your data with simplified data capture, easy integration with third-party providers and pioneering ML data analysis.',
  },
  ArHeroHeader: {
    animation: {
      id: 'build_hero',
    },
    title: 'Transforming data',
    description: 'Integrated data capture and augmentation.',
    cta: {
      label: 'Request a demo',
    },
  },
  ArTextWithImage: {
    items: [
      {
        title: 'Collect once, use everywhere',
        description: [
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform makes data capture simple. Data need only be collected once - so there’s no need to rekey information into other platforms.',
          { tag: 'br' },
          { tag: 'br' },
          'Our tools can even digitise data from paper-based submissions or extract points from text and image-based documents using pioneering Machine Learning techniques.',
          { tag: 'br' },
          { tag: 'br' },
          'All information is stored securely in one place and integration with other apps is simple. Use it to determine indicative premiums, establish the relative quality of risks and negotiate placement terms digitally in real time.',
        ],
        images: [
          { url: withPrefix('img/ArTextWithImage16.png'), alt: 'Artificial Build for insurance' },
          { url: withPrefix('img/ArTextWithImage16.png'), alt: 'Artificial Build for insurance' },
          { url: withPrefix('img/ArTextWithImage16.png'), alt: 'Artificial Build for insurance' },
        ],
        scImageMargins: {
          right: ['0', '-120px', '0'],
          bottom: ['30px', '0', '0'],
          left: ['10px', '0', '0'],
        },
        scComponentMargins: {
          top: ['0', '0', '0'],
          bottom: ['0', '0', '0'],
        },
        scGap: [0, 30, 193],
        scFlexAlign: 'center',
        scTitleMaxWidth: ['none', '277px', '320px'],
      },
    ],
  },
  ArTextWithImageStacked: {
    items: [
      {
        title: 'Negotiate policies digitally',
        description: [
          'Digital submissions eliminate the need for paperwork so you can collaborate with business partners all in one place.',
          { tag: 'br' },
          { tag: 'br' },
          'Cloud-based submissions give all parties in the value chain instant access to documents and streamline time-consuming processes - giving you the time to focus on what really matters.',
        ],
        images: [
          { url: withPrefix('img/ArTextWithImage11a.png'), alt: 'Negotiate insurance policies digitally with Artificial Build' },
          { url: withPrefix('img/ArTextWithImage11b.png'), alt: 'Negotiate insurance policies digitally with Artificial Build' },
          { url: withPrefix('img/ArTextWithImage11b.png'), alt: 'Negotiate insurance policies digitally with Artificial Build' },
        ],
        scImageMargins: {
          right: ['-25px', '-38px', '0'],
          bottom: ['-5px', '36px', '0'],
          left: ['-25px', '-38px', '-102px'],
        },
        scComponentMargins: {
          top: ['-10px', '40px', '217px'],
          bottom: ['0', '0', '0'],
        },
        scDesktopGap: 35,
        scImageWidthOnDesktop: '64%',
      },
      {
        title: 'Automate your workflow',
        description: [
          'Give your underwriters more time and freedom to focus on complex policies as high-volume, low-margin tasks are completed for them.',
          { tag: 'br' },
          { tag: 'br' },
          'Automatic scoring uses data to demonstrate the quality of a risk, its fit within the current portfolio of business and the likelihood of a potential claim. Brokers and underwriters then receive a reliable initial analysis of any submission, without the heaps of paperwork.',
        ],
        animation: {
          id: 'build_automate',
        },
        // images: [
        //   { url: withPrefix('img/ArTextWithImage3a.png') },
        //   { url: withPrefix('img/ArTextWithImage3b.png') },
        //   { url: withPrefix('img/ArTextWithImage3b.png') },
        // ],
        // scImageMargins: {
        //   right: ['-25px', '10px', '-88px'],
        //   bottom: ['20px', '15px', '-55px'],
        //   left: ['-25px', '10px', '0'],
        // },
        scComponentMargins: {
          top: ['20px', '85px', '180px'],
          bottom: ['50px', '0', '0'],
        },
        // scDesktopGap: 70,
        scImageWidthOnDesktop: '61%',
        scInverseStack: true,
        scCenterTextOnDesktop: true,
        scTextWrapperMaxWidthOnDesktop: '600px',
        scDescMaxWidth: [null, null, '600px'],
      },
    ],
  },
  ArDocumentColumns: {
    columns: [
      {
        image: {
          alt: 'Integrate and enrich your insurance data',
          url: withPrefix('img/ArDocumentColumns1.png'),
        },
        title: 'Integrate and enrich data',
        description: 'Don’t settle for simple data. Our applications are API-first and allow for seamless third-party integration - so your underwriters and brokers can make fully-informed decisions without the effort of traditional data collection.',
      },
      {
        image: {
          alt: 'Generate insurance documents in real time',
          url: withPrefix('img/ArDocumentColumns2.png'),
        },
        title: 'Generate documents',
        description: 'Save time and money with our document generation feature. Build quote and policy documents instantly based on real time user-entered data and templates specific to your business, and support your internal processes with our configured workflow engines.',
      },
    ],
  },
  ArCTASection: {
    title: 'Want to learn more?',
    cta: {
      label: 'Contact Us',
      url: routesConfig.contact(),
    },
    backgroundColor: variables.colors.asfalt,
  },
}
